import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getProductByLocation } from '../helpers/store';
import { isShippingRestrictedForParent } from '../helpers/internationalRestriction';
import ConfigScreen from './configScreen';

const gridStyle = {};

// The "some items hidden" notice itself is rendered inside SlotSelector,
// under the bundle title where it's contextual to the slot grid the parent
// is filling — that keeps it out of the back-button area at the top.
export const Product = ({ shoot, parent, ...props }) => {
  const product = getProductByLocation(shoot?.shootProducts, props.location);
  const { child_products } = product;

  const restricted = isShippingRestrictedForParent(shoot?.shoot, parent);
  const visibleChildren =
    restricted && Array.isArray(child_products)
      ? child_products.filter((c) => c?.requires_shipping !== true)
      : child_products;

  return (
    <ConfigScreen
      itemsDesktop={4}
      itemsMobile={2}
      gridStyle={gridStyle}
      items={visibleChildren}
      instruction="Select a Product"
    />
  );
};

const mapStateToProps = (state) => ({
  shoot: state.shoot,
  parent: state.parent,
});

export default withRouter(connect(mapStateToProps)(Product));
